import { PREFERENCES_DEFINITIONS } from './constants';

/**
 * Extract the default value of all the given preferences keys
 * @param  {String[]} preferencesKeys - list of preferences (i.e. keys)
 * @return {Object} an object with all the keys defined in "preferencesKeys",
 *                  and the default values extracted from the PREFERENCES_DEFINITIONS
 * @throws Will throw an error if a key if not defined in the PREFERENCES_DEFINITIONS object
 */
const extractDefaultPreferences = (preferencesKeys) =>
    preferencesKeys.reduce((accu, key) => {
        if (PREFERENCES_DEFINITIONS[key] === undefined)
            throw new Error(
                `Undefined preference key: "${key}". Please ensure all preferences are defined in 'app/containers/App/session/constants.'`,
            );
        return {
            ...accu,
            [key]: PREFERENCES_DEFINITIONS[key].defaultValue,
        };
    }, {});

export { extractDefaultPreferences };
